import { CompanyDocumentsRouteQuery } from 'generated/resources/graphql'

export const canSeePublicFilesTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.companySeePublicDocuments.can

export const canSeeInternalFilesTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.companySeeInternalDocuments.can

export const canSeeEmployeeFilesTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.employeeManageAnyEmployeeFolder.can ||
  data?.documents?._policies?.employeeSeeEmployeeFiles.can

export const canSeeSendInBulkTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.employeeManageAnyEmployeeFolder.can

export const canSeeTemplatesTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.templateManageDocumentTemplates.can

export const canSeeEmployeeTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.employeeEditDocumentsTrashBin.can ||
  data?.documents?._policies?.employeeManageAnyEmployeeFolder.can || // TODO deprecate when removing dev_document_folder_permissions
  data?.documents?._policies?.employeeManageDefaultEmployeeFolder.can || // TODO deprecate when removing dev_document_folder_permissions
  data?.documents?._policies?.employeeEditAnyEmployeeFolder.can

export const canSeePublicTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.companyEditPublicDocuments.can

export const canSeeInternalTab = (data: CompanyDocumentsRouteQuery) =>
  data?.documents?._policies?.companyUseCompanyDocuments.can ||
  data?.documents?._policies?.companyEditInternalDocuments.can

export const canSeeTrashTab = (data: CompanyDocumentsRouteQuery) =>
  canSeeEmployeeTab(data) || canSeePublicTab(data) || canSeeInternalTab(data)
